import { useCallback, useEffect, useRef } from 'react';

import { useAutoRefreshStore } from '../store/auto-refresh.store';

export function useLongPoolingQueryHelper(
  refreshCacheName: string,
  isLoading: boolean,
  refetch?: () => void,
) {
  const refreshInterval = useAutoRefreshStore(s => s.entities[refreshCacheName]?.interval ?? 0);
  const setLoading = useAutoRefreshStore(s => s.setLoading);
  const previousRefreshIntervalRef = useRef(refreshInterval);

  // Immediate refetch when auto-refresh is enabled
  useEffect(() => {
    const previousInterval = previousRefreshIntervalRef.current;

    if (previousInterval === 0 && refreshInterval > 0 && refetch) {
      // Auto-refresh was just enabled - trigger immediate refetch
      refetch();
    }

    previousRefreshIntervalRef.current = refreshInterval;
  }, [refreshInterval, refetch]);

  // Handle loading state change for auto-refresh only
  const handleLoadingChange = useCallback(
    (isLoading: boolean) => {
      if (refreshInterval > 0) {
        setLoading(refreshCacheName, isLoading);
      }
    },
    [refreshInterval, setLoading, refreshCacheName],
  );

  // Handle loading state change for auto-refresh
  useEffect(() => {
    if (refreshInterval > 0) {
      handleLoadingChange(isLoading);
    }
  }, [refreshInterval, handleLoadingChange, isLoading]);
}
